import { Injectable } from '@angular/core';
import { AbstractAppConfig } from '../../../app.config';
import { AddressModel, AddressesModel } from '../../domain/addresses';
import { HttpErrorService } from '../http';
import { map, catchError } from 'rxjs/operators';
import { plainToClass } from 'class-transformer';
import { throwError, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AddressesService {

  constructor(private httpClient: HttpClient, private errorService: HttpErrorService, private appConfig: AbstractAppConfig) {
  }

  getAddressesForPostcode(postcode: string): Observable<AddressModel[]> {
    return this.httpClient
      .get<AddressModel[]>(this.appConfig.getPostcodeLookupUrl().replace('${postcode}', postcode))
      .pipe(
        catchError(error => {
          this.errorService.setError(error);
          return throwError(error);
        }),
        map((o: Object) => plainToClass(AddressesModel, o)),
        map(output => output.addresses.map(address => this.format(address)))
      );
  }

  private format(addressModel: AddressModel) {
    return this.formatAddressLines(this.shiftAddressLinesUp(addressModel));
  }

  private formatAddressLines(addressModel: AddressModel) {
    ['AddressLine1', 'AddressLine2', 'AddressLine3', 'PostTown'].forEach(value => {
      addressModel[value] = this.toCapitalCase(addressModel[value]);
    });
    return addressModel;
  }

  private shiftAddressLinesUp(addressModel: AddressModel) {
    if (addressModel.AddressLine2 === '') {
      addressModel.AddressLine2 = addressModel.AddressLine3;
      addressModel.AddressLine3 = '';
    }
    if (addressModel.AddressLine1 === '') {
      addressModel.AddressLine1 = addressModel.AddressLine2;
      addressModel.AddressLine2 = '';
    }
    return addressModel;
  }

  private toCapitalCase(sentence: string) {
    sentence = sentence.toLowerCase();
    sentence.split(' ').forEach((value, index) => {
        sentence = sentence.replace(value, value.charAt(0).toUpperCase() + value.substr(1));
      }
    );
    return sentence;
  }
}
